import PropTypes from 'prop-types';
import { useTheme, styled } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
import { PointOfSaleRounded } from '@mui/icons-material';

import SystemStatSkeleton from '../skeletons/SystemStatsSkeleton';
import MainCard from '../../../common/cards/MainCard';

const CardWrapper = styled(MainCard)(({ theme }) => ({
  color: '#fff',
  overflow: 'hidden',
  position: 'relative',
  borderRadius: '1rem',
  '&>div': {
    position: 'relative',
    zIndex: 5,
  },
  '&:after': {
    content: '""',
    position: 'absolute',
    width: 210,
    height: 210,
    background: `linear-gradient(210.04deg, ${theme.palette.secondary.dark} -6%, rgba(144, 202, 249, 0) 84%)`,
    borderRadius: '50%',
    zIndex: 1,
    top: -85,
    right: -95,
    [theme.breakpoints.down('sm')]: {
      top: -105,
      right: -140,
    },
  },
  '&:before': {
    content: '""',
    position: 'absolute',
    zIndex: 1,
    width: 210,
    height: 210,
    background: `linear-gradient(140.9deg, ${theme.palette.secondary.dark} -4%, rgba(144, 202, 249, 0) 71%)`,
    borderRadius: '50%',
    top: -125,
    right: -15,
    opacity: 0.5,
    [theme.breakpoints.down('sm')]: {
      top: -155,
      right: -70,
    },
  },
}));

const TotalTerminalCard = ({ isLoading, data }) => {
  const theme = useTheme();

  return (
    <>
      {isLoading ? (
        <SystemStatSkeleton />
      ) : (
        <CardWrapper border={false} content={false}>
          <Box sx={{ p: 2.25 }}>
            <Grid container direction="column">
              <Grid item>
                <Grid container justifyContent="space-between">
                  <Grid item>
                    <PointOfSaleRounded
                      sx={{
                        fontSize: '3.5rem',
                        color: theme.palette.text.primary,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container alignItems="center">
                  <Grid item>
                    <Typography
                      sx={{
                        fontSize: '2.125rem',
                        fontWeight: 500,
                        mx: 1,
                        mt: 1.75,
                        mb: 0.75,
                        color: theme.palette.text.primary,
                      }}
                    >
                      {data.allTerminals.length}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sx={{ mb: 1.25 }}>
                <Typography
                  sx={{
                    fontSize: '1rem',
                    fontWeight: 500,
                    color: theme.palette.text.primary,
                  }}
                >
                  Total Terminals
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardWrapper>
      )}
    </>
  );
};

TotalTerminalCard.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.object,
};

export default TotalTerminalCard;
